import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.object.define-properties";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

var _marked = /*#__PURE__*/regeneratorRuntime.mark(_callee);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { take, put, call } from 'redux-saga/effects';
import network from '../../../network/network';
import { workingStart, workingEnd } from '../../working/actions';
import * as actions from '../actions';
export default function _callee() {
  var _loop;

  return regeneratorRuntime.wrap(function _callee$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop() {
            var _yield$take, payload, url, onSuccess, onFailure, rest, allData, data, response;

            return regeneratorRuntime.wrap(function _loop$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return take(actions.INTERDICTION_REQUEST_NEW_CODE);

                  case 2:
                    _yield$take = _context.sent;
                    payload = _yield$take.payload;
                    url = payload.reSendURL, onSuccess = payload.onSuccess, onFailure = payload.onFailure, rest = _objectWithoutProperties(payload, ["reSendURL", "onSuccess", "onFailure"]);
                    allData = _objectSpread({}, rest);
                    data = Object.keys(allData).filter(function (key) {
                      return typeof allData[key] !== 'undefined';
                    }).reduce(function (res, key) {
                      return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, key, allData[key]));
                    }, {});
                    _context.next = 9;
                    return put(workingStart());

                  case 9:
                    _context.prev = 9;
                    _context.next = 12;
                    return network().post({
                      url: url,
                      data: data,
                      includeRootContext: false
                    });

                  case 12:
                    response = _context.sent;

                    if (!onSuccess) {
                      _context.next = 16;
                      break;
                    }

                    _context.next = 16;
                    return call(onSuccess, response);

                  case 16:
                    _context.next = 18;
                    return put(workingEnd());

                  case 18:
                    _context.next = 25;
                    break;

                  case 20:
                    _context.prev = 20;
                    _context.t0 = _context["catch"](9);

                    if (!onFailure) {
                      _context.next = 25;
                      break;
                    }

                    _context.next = 25;
                    return call(onFailure, _context.t0);

                  case 25:
                  case "end":
                    return _context.stop();
                }
              }
            }, _loop, null, [[9, 20]]);
          });

        case 1:
          if (!true) {
            _context2.next = 5;
            break;
          }

          return _context2.delegateYield(_loop(), "t0", 3);

        case 3:
          _context2.next = 1;
          break;

        case 5:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked);
}